import React from "react";
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const AreaList = React.lazy(() => import("./pages/AreaList"));
const ExhibitorList = React.lazy(() => import("./pages/ExhibitorList"));
const VisitorRequestList = React.lazy(() => import("./pages/VisitorRequestList"));
const AcceptedVisitorList = React.lazy(() => import("./pages/AcceptedVisitorList"));
const HoldVisitorList = React.lazy(() => import("./pages/HoldVisitorList"));
const RejectedVisitorList = React.lazy(() => import("./pages/RejectedVisitorList"));
const BuyersRequestList = React.lazy(() => import("./pages/BuyersRequestList"));
const BuyersInvitedList = React.lazy(() => import("./pages/BuyersInvitedList"));
const BuyersRecycledList = React.lazy(() => import("./pages/BuyersRecycledList"));
const VendorList = React.lazy(() => import("./pages/VendorList"));
const HotelList = React.lazy(() => import("./pages/HotelList"));

export const subAdminRoutes = [
  {
    path: "/subadmin/dashboard",
    exact: true,
    booleanValue: "subadmin",
    element: Dashboard,
  },
  {
    path: "/subadmin/area-list",
    exact: true,
    booleanValue: "subadmin",
    element: AreaList,
  },
  {
    path: "/subadmin/exhibitor-list",
    exact: true,
    booleanValue: "subadmin",
    element: ExhibitorList,
  },
  {
    path: "/subadmin/vendor-list",
    exact: true,
    booleanValue: "subadmin",
    element: VendorList,
  },
  {
    path: "/subadmin/visitors/requests",
    exact: true,
    booleanValue: "subadmin",
    element: VisitorRequestList,
  },
  {
    path: "/subadmin/visitors/accepted",
    exact: true,
    booleanValue: "subadmin",
    element: AcceptedVisitorList,
  },
  {
    path: "/subadmin/visitors/hold",
    exact: true,
    booleanValue: "subadmin",
    element: HoldVisitorList,
  },
  {
    path: "/subadmin/visitors/rejected",
    exact: true,
    booleanValue: "subadmin",
    element: RejectedVisitorList,
  },
  {
    path: "/subadmin/buyers/requests",
    exact: true,
    booleanValue: "subadmin",
    element: BuyersRequestList,
  },
  {
    path: "/subadmin/buyers/invited",
    exact: true,
    booleanValue: "subadmin",
    element: BuyersInvitedList,
  },
  {
    path: "/subadmin/buyers/recycled",
    exact: true,
    booleanValue: "subadmin",
    element: BuyersRecycledList,
  },
  {
    path: "/subadmin/hotel-list",
    exact: true,
    booleanValue: "subadmin",
    element: HotelList,
  },
];
